import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  changePasswordRequest: ["password", "old_password"],
  changePasswordSuccess: ["status"],
  changePasswordFailure: ["error"],
});

export const ChangePasswordTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  password: null,
  old_password: null,
  fetching: false,
  success: false,
  error: false,
  errorMessage: null,
  status: null,
});

export const ChangePasswordSelectors = {
  getData: (state: any) => state.changePassword.data,
  isFetching: (state: any) => state.changePassword.fetching,
  isSuccess: (state: any) => state.changePassword.success,
  hasError: (state: any) => state.changePassword.error,
  getPassword: (state: any) => state.changePassword.password,
  getOldPassword: (state: any) => state.changePassword.old_password,
  getStatus: (state: any) => state.changePassword.status,
};

export const request = (state: any, { password, old_password }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    errorMessage: null,
    password,
    old_password,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    errorMessage: null,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    errorMessage: action.error || action.data || 'An error occurred',
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CHANGE_PASSWORD_REQUEST]: request,
  [Types.CHANGE_PASSWORD_SUCCESS]: success,
  [Types.CHANGE_PASSWORD_FAILURE]: failure,
});
